import { useEffect } from "react";
import Box from "@mui/material/Box";
import leftPredictionPerson from "../../assets/images/Kamala harris pic.png";
import rightPredictionPerson from "../../assets/images/Donald trump pic.png";
import { useDispatch, useSelector } from "react-redux";
import {
  getElectoralVotes,
  getElectoralVotesAverage,
} from "../../redux/actions/pollingAction";
import { useNavigate, useSearchParams } from "react-router-dom";

function ElectionSeatPredictionComp({ type = "popular-polls", selectedYear }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const types = searchParams.get("type");
  const quary = `year=${selectedYear}`;
  const isVerified = localStorage.getItem("accessToken");
  // useEffect(() => {
  //   if (!isVerified) {
  //     navigate("/login");
  //   }
  // }, []);
  const pollPayload = types
    ? { country: localStorage.getItem("country") }
    : {
      country: localStorage.getItem("country"),
      state: localStorage.getItem("state"),
    };
  const pollAvgPayload = types
    ? { country: localStorage.getItem("country"), pollType: `${type}` }
    : {
      country: localStorage.getItem("country"),
      state: localStorage.getItem("state"),
      pollType: `${type}`,
    };
  useEffect(() => {
    // console.log("🚀 ~ ElectionSeatPredictionComp ~ pollPayload:", pollPayload);
    dispatch(getElectoralVotes(pollPayload, quary));
    dispatch(getElectoralVotesAverage(pollAvgPayload, quary));
    // console.log("type", type);
  }, [type, quary]);

  const { electoralVotesResponse, electoralVotesAverageResponse } = useSelector(
    (state) => state?.pollWeb
  );
  console.log("🚀 ~ ElectionSeatPredictionComp ~ electoralVotesResponse:", electoralVotesResponse)
  console.log("🚀 ~ ElectionSeatPredictionComp ~ electoralVotesAverageResponse:", electoralVotesAverageResponse)
    const processCandidatesData = () => {
    if (!electoralVotesResponse || !Array.isArray(electoralVotesResponse)) return [];

    // Find democrat and republican candidates
    const demCandidate = electoralVotesResponse.find(candidate => 
      candidate.party?.abbreviation === "dem"
    );
    const repCandidate = electoralVotesResponse.find(candidate => 
      candidate.party?.abbreviation === "rep"
    );

    return [demCandidate, repCandidate].filter(Boolean);
  };

  const processAverageData = () => {
    if (!electoralVotesAverageResponse || !Array.isArray(electoralVotesAverageResponse)) return {};

    const demAvg = electoralVotesAverageResponse.find(avg => 
      avg.abbreviation === "dem"
    );
    const repAvg = electoralVotesAverageResponse.find(avg => 
      avg.abbreviation === "rep"
    );

    return {
      dem_Average: demAvg?.result,
      rep_Average: repAvg?.result,
      toWin: demAvg?.toWin || repAvg?.toWin,
      dem_candidate: demAvg?.result,
      rep_candidate: repAvg?.result
    };
  };
  const candidates = processCandidatesData();
  const averageData = processAverageData();
  // console.log("🚀 ~ ElectionSeatPredictionComp ~ candidates:", candidates);

  function calculateSeatsPercentage(candidate1Seats, candidate2Seats) {
    const totalSeats = 538;
    const candidate1Percentage = (candidate1Seats / totalSeats) * 100;
    const candidate2Percentage = (candidate2Seats / totalSeats) * 100;

    return {
      candidate1Percentage,
      candidate2Percentage,
    };
  }

  const percentages = calculateSeatsPercentage(
    electoralVotesResponse?.votesForHarris,
    electoralVotesResponse?.votesForTrump
  );

  // const generateGradient = () => {
  //   return `linear-gradient(to right, rgb(66,82,168) ${percentages.candidate1Percentage}%, rgb(255, 61, 61) ${percentages.candidate1Percentage}%)`;
  // };

  // const generateGradient = () => {
  //   return `linear-gradient(to right, rgb(66,82,168) 0%, rgba(66,82,168,0.15) ${percentages.candidate1Percentage}%, rgba(2255, 61, 61,0.15) ${percentages.candidate1Percentage}%, rgb(255, 61, 61) 100%)`;
  // };
  const generateGradient = () => {
    if (candidates.length !== 2) return "";

    const color1 = candidates[0]?.party?.color_code || "#4252A8"; // Fallback blue
    const color2 = candidates[1]?.party?.color_code || "#E60A00"; // Fallback red

    const c1Percent = percentages.candidate1Percentage || 50;

    return `linear-gradient(to right,
      ${color1} 0%,
      ${hexToRGBA(color1, 0.15)} ${c1Percent}%,
      ${hexToRGBA(color2, 0.15)} ${c1Percent}%,
      ${color2} 100%)`;
  };
  const hexToRGBA = (hex, alpha) => {
    let r = 0,
      g = 0,
      b = 0;

    // 3-digit format (#RGB)
    if (hex.length === 4) {
      r = parseInt(hex[1] + hex[1], 16);
      g = parseInt(hex[2] + hex[2], 16);
      b = parseInt(hex[3] + hex[3], 16);
    } else if (hex.length === 7) {
      // 6-digit format (#RRGGBB)
      r = parseInt(hex[1] + hex[2], 16);
      g = parseInt(hex[3] + hex[4], 16);
      b = parseInt(hex[5] + hex[6], 16);
    }

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  const handleValue = (val) => {
    if (val) {
      return `${Math.round(val)}%`;
    }
    return "No Data";
  };
  const handleRawValue = (val) => {
    if (val !== undefined && val !== null) {
      return `${val}`;
    }
    return "No Data";
  };

  return (
    <>
      {candidates.length === 2 ? (
        <>
          {/* Images and Names with "VS" */}
          <div className="flex flex-row justify-center items-center gap-9 py-10 my-10">
            {/* Candidate 1 */}
            <div className="flex flex-col items-center">
              <img
                src={candidates[0]?.profile?.url}
                alt={candidates[0]?.name}
                className="w-24 h-24 object-cover"
              />
            </div>

            {/* VS */}
            <span className="flex flex-col text-center justify-center">VS</span>

            {/* Candidate 2 */}
            <div className="flex flex-col items-center">
              <img
                src={candidates[1]?.profile?.url}
                alt={candidates[1]?.name}
                className="w-24 h-24 object-cover"
              />
            </div>
          </div>

          {/* Bar UI */}
          <div className="flex justify-center">
            <Box
              sx={{
                width: 600,
                height: 20,
                position: "relative",
                paddingLeft: "2px",
                paddingRight: "2px",
                background: generateGradient(),
              }}
            >
              <div 
                className="text-3xl absolute left-0 bottom-8"
                style={{ color: candidates[0]?.party?.color_code || "#0042C9" }}
              >
                {type === "popular-polls"
                  ? handleValue(averageData.dem_Average)
                  : handleRawValue(averageData.dem_candidate)}
              </div>

              {/* Republican Value */}
              <div 
                className="text-3xl absolute right-0 bottom-8"
                style={{ color: candidates[1]?.party?.color_code || "#fc0303" }}
              >
                {type === "popular-polls"
                  ? handleValue(averageData.rep_Average)
                  : handleRawValue(averageData.rep_candidate)}
              </div>

              {/* Candidate Names */}
              <div className="absolute left-0 top-8 text-left">
                <div className="font-medium">{candidates[0]?.name}</div>
              </div>
              
              <div className="absolute right-0 top-8 text-right">
                <div className="font-medium">{candidates[1]?.name}</div>
              </div>

              {/* To Win Info */}
              <div className="absolute left-1/2 top-12 transform -translate-x-1/2 text-xs text-gray-500 whitespace-nowrap">
                {type === "popular-polls"
                  ? averageData.toWin
                    ? `${averageData.toWin}% to win`
                    : "No Data"
                  : averageData.toWin
                    ? `${averageData.toWin} to win`
                    : "No Data"}
              </div>

              {/* Pointer in the middle of the bar */}
              <div
                style={{
                  position: "absolute",
                  top: "-60%",
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "2px",
                  height: "60px",
                  backgroundColor: "#000",
                }}
              ></div>
            </Box>
          </div>
        </>
      ) : (
        <>
          <div className="text-3xl text-center mt-[5rem]">No Data</div>
        </>
      )}
    </>
  );
}

export default ElectionSeatPredictionComp;
